"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _reactOverlays = require("react-overlays");

var _transitionClass = _interopRequireDefault(require("../transitionClass"));

var _getElementPosition = _interopRequireDefault(require("../getElementPosition"));

var _getScreenSize = _interopRequireDefault(require("../getScreenSize"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n\n  border-width: ", ";\n  border-color: ", ";\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: fixed;\n\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: row;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BACKSTYLE = {
  position: 'fixed'
};

var SvgQuestionMark = function SvgQuestionMark(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, props), _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M9.003 0A8.996 8.996 0 0 1 18 8.997C18 13.967 13.973 18 9.003 18A9 9 0 0 1 0 9.003v-.006A8.996 8.996 0 0 1 9.003 0zm0 1C4.59 1 1 4.587 1 8.997 1.006 13.412 4.596 17 9.003 17 13.413 17 17 13.41 17 8.997 17 4.587 13.413 1 9.003 1zm.205 10.806a.724.724 0 0 1 .217.532.726.726 0 0 1-.217.53.725.725 0 0 1-.53.216.71.71 0 0 1-.52-.216.722.722 0 0 1-.218-.53.72.72 0 0 1 .217-.531.707.707 0 0 1 .52-.218c.21 0 .386.072.531.217zm1.901-6.284c.445.404.667.957.667 1.657 0 .78-.213 1.34-.639 1.68-.427.34-1.059.512-1.897.52v1.322H8.07V8.534h.52c.448.007.815-.026 1.1-.098.285-.072.507-.206.666-.4.16-.196.24-.48.24-.856 0-.383-.112-.683-.332-.9-.22-.216-.525-.325-.915-.325s-.698.104-.92.314c-.225.21-.337.502-.337.877h-1.16c0-.433.098-.819.293-1.159.195-.34.475-.603.84-.79.364-.189.79-.282 1.273-.282.737 0 1.327.202 1.771.606z",
    fill: "currentColor"
  })));
};

var SvgTooltipArrowUp = function SvgTooltipArrowUp(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "21",
    height: "21",
    viewBox: "0 0 21 12"
  }, props), _react.default.createElement("path", {
    d: "M11.942 1.414l8.338 8.338a.915.915 0 0 1-.648 1.562H1.37a.893.893 0 0 1-.632-1.525l8.376-8.375a2 2 0 0 1 2.828 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var SvgTooltipArrowDown = function SvgTooltipArrowDown(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "21",
    height: "21",
    viewBox: "0 0 21 12"
  }, props), _react.default.createElement("path", {
    d: "M11.942 10.597L20.28 2.26a.915.915 0 0 0-.648-1.562H1.37a.893.893 0 0 0-.632 1.524l8.376 8.375a2 2 0 0 0 2.828 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var Container = _native.default.View(_templateObject(), function (_ref) {
  var muistyles = _ref.muistyles;
  return muistyles.margin;
});

var IconContainer = _native.default.Text(_templateObject2(), function (props) {
  return props.hover ? props.muistyles.iconHoverColor : props.muistyles.iconColor;
});

var ArrowContainer = _native.default.Text(_templateObject3(), function (props) {
  return props.muistyles.tooltipBackgroundColor;
});

var TooltipContainer = _native.default.View(_templateObject4(), function (props) {
  return props.muistyles.tooltipBackgroundColor;
}, function (props) {
  return props.muistyles.tooltipBorderRadius;
}, function (props) {
  return props.muistyles.tooltipPadding;
}, function (props) {
  return props.muistyles.tooltipBorderWidth;
}, function (props) {
  return props.muistyles.tooltipBorderColor;
}, function (_ref2) {
  var muistyles = _ref2.muistyles;
  return muistyles.tooltipShadow && " shadow-color: #000;\n       shadow-offset: {width: 0, height: 0};\n       shadow-opacity: 0.1;\n       shadow-radius: 8;\n    ";
});

var Tooltip =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Tooltip, _Component);

  function Tooltip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "containerRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      containerPos: {},
      screenSize: {},
      hover: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPosition", function () {
      _this.setState({
        containerPos: (0, _getElementPosition.default)(_this.containerRef.current),
        screenSize: (0, _getScreenSize.default)()
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTooltipTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('Tooltip', props, context);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseOver", function () {
      _this.setState({
        hover: true
      }, _this.getPosition);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseLeave", function () {
      _this.setState({
        hover: false
      });
    });
    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.getPosition();
    window.addEventListener('scroll', this.getPosition);
    window.addEventListener('resize', this.getPosition);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.getPosition);
    window.removeEventListener('resize', this.getPosition);
  };

  _proto.getTooltipStyles = function getTooltipStyles(theme) {
    if (!this.state.containerPos) {
      return {};
    }

    var marginLeft = (theme.tooltipWidth - theme.iconSize) / 2 * -1 + (this.props.offset || 0);

    if (this.state.containerPos.x + marginLeft < 0) {
      marginLeft = -(this.state.containerPos.x - 10);
    }

    if (this.state.containerPos.x + theme.tooltipWidth + marginLeft > this.state.screenSize.width) {
      marginLeft = (theme.tooltipWidth + 10 - (this.state.screenSize.width - this.state.containerPos.x)) * -1;
    }

    var baseStyles = (0, _objectSpread2.default)({}, BACKSTYLE, {
      width: theme.tooltipWidth,
      left: this.state.containerPos.x,
      zIndex: theme.zIndex,
      marginLeft: marginLeft
    });

    if (!this.props.top) {
      return (0, _objectSpread2.default)({}, baseStyles, {
        top: this.state.containerPos.y + 30
      });
    }

    return (0, _objectSpread2.default)({}, baseStyles, {
      bottom: this.state.screenSize.height - this.state.containerPos.y + 18
    });
  };

  _proto.getArrowStyles = function getArrowStyles() {
    if (!this.state.containerPos) {
      return {};
    }

    if (!this.props.top) {
      return {
        top: this.state.containerPos.y + 18,
        left: this.state.containerPos.x - 3
      };
    }

    return {
      bottom: this.state.screenSize.height - this.state.containerPos.y + 2,
      left: this.state.containerPos.x - 3
    };
  };

  _proto.render = function render() {
    var children = this.props.children;
    var muistyles = this.getTooltipTheme(this.props, this.context);
    return _react.default.createElement(Container, {
      muistyles: muistyles
    }, _react.default.createElement("div", {
      ref: this.containerRef
    }, _react.default.createElement(IconContainer, {
      className: _transitionClass.default,
      onMouseOver: this.onMouseOver,
      onMouseLeave: this.onMouseLeave,
      hover: this.state.hover,
      muistyles: muistyles
    }, _react.default.createElement(SvgQuestionMark, {
      width: muistyles.iconSize,
      height: muistyles.iconSize
    }))), this.state.hover && _react.default.createElement(_reactOverlays.Modal, {
      show: true,
      style: this.getTooltipStyles(muistyles)
    }, _react.default.createElement("div", null, _react.default.createElement(TooltipContainer, {
      muistyles: muistyles
    }, _react.default.createElement("div", null, children)), _react.default.createElement(ArrowContainer, {
      muistyles: muistyles,
      style: this.getArrowStyles()
    }, !this.props.top ? _react.default.createElement(SvgTooltipArrowUp, null) : _react.default.createElement(SvgTooltipArrowDown, null)))));
  };

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;
(0, _defineProperty2.default)(Tooltip, "contextType", _ThemeProvider.default);